import styled from 'styled-components';
import { ModalShareConfigurationBasketStyled } from '../ModalShareConfigurationBasketStyled';

export const ModalShareConfigurationBasketStyledOV = styled(ModalShareConfigurationBasketStyled)`
    .phone {
        color: ${({ theme }) => theme.colors.black};
    }
`;
